import React from "react";
import { Box, ButtonBase } from "@mui/material";
import {
  PROJECT_COLOR,
  TEXT_COLOR_PRIMARY,
  BORDER_COLOR_LIGHT,
} from "../../constants/colors";
import { FONT_SIZE } from "../../constants/fontSizes";

const NavigationNoticeCard = ({
  title,
  description,
  actionLabel,
  onClick,
  icon,
  isDesktop = true,
  color = PROJECT_COLOR,
  backgroundColor = `${PROJECT_COLOR}12`,
  borderColor = BORDER_COLOR_LIGHT,
  hoverColor = `${PROJECT_COLOR}20`,
}) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: isDesktop ? "center" : "stretch",
        justifyContent: "space-between",
        flexDirection: isDesktop ? "row" : "column",
        gap: isDesktop ? 1.5 : 1,
        px: isDesktop ? 1.8 : 1.4,
        py: isDesktop ? 1.2 : 1.4,
        borderRadius: "14px",
        backgroundColor,
        border: `1px dashed ${borderColor}`,
        cursor: "pointer",
        transition: "0.2s",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left",
        "&:hover": {
          backgroundColor: hoverColor,
        },
      }}
    >
      {/* 左側 */}
      <Box
        sx={{
          display: "flex",
          alignItems: !isDesktop && description ? "flex-start" : "center",
          gap: 1,
          minWidth: 0,
          width: "100%",
        }}
      >
        {/* アイコン */}
        <Box
          sx={{
            width: isDesktop ? 36 : 30,
            height: isDesktop ? 36 : 30,
            borderRadius: "999px",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color,
            flexShrink: 0,
            mt: isDesktop ? 0 : 0.2,
          }}
        >
          {icon}
        </Box>

        {/* テキスト */}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              fontSize: FONT_SIZE.XS,
              fontWeight: 700,
              color,
              wordBreak: "break-word",
              lineHeight: 1.5,
            }}
          >
            {title}
          </Box>

          {description && (
            <Box
              sx={{
                fontSize: FONT_SIZE.XS,
                color: TEXT_COLOR_PRIMARY,
                mt: 0.3,
                wordBreak: "break-word",
                lineHeight: 1.6,
              }}
            >
              {description}
            </Box>
          )}
        </Box>
      </Box>

      {/* 右リンク */}
      <Box
        sx={{
          fontSize: FONT_SIZE.XS,
          fontWeight: 700,
          color,
          whiteSpace: "nowrap",
          flexShrink: 0,
          alignSelf: isDesktop ? "center" : "stretch",
          textAlign: isDesktop ? "left" : "center",
          mt: isDesktop ? 0 : 0.2,
          py: isDesktop ? 0 : 0.7,
          borderRadius: isDesktop ? 0 : "999px",
          backgroundColor: isDesktop ? "transparent" : "#FFFFFF",
        }}
      >
        {actionLabel}
      </Box>
    </ButtonBase>
  );
};

export default NavigationNoticeCard;
